export const SHORTCUTS = {
  goToOverview: 'alt+o',
  goToGuidelines: 'alt+g',
  goToWorkflows: 'alt+w',
  goToLogs: 'alt+l',
  goToMcps: 'alt+m',
  goToInsights: 'alt+i',
  goToVersions: 'alt+v',
  goToSettings: 'alt+s',
  goToSimulations: 'alt+r',
  goToImprovements: 'alt+n',
  exportAgent: 'alt+e',
  test: 'alt+t',
  publish: 'alt+p',
  toggleSidebar: 'alt+bracketleft',
} as const;
